import { render, staticRenderFns } from "./FabricCompositionIndex.vue?vue&type=template&id=0be4b9c5&scoped=true&"
import script from "./FabricCompositionIndex.vue?vue&type=script&lang=js&"
export * from "./FabricCompositionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4b9c5",
  null
  
)

export default component.exports